// @flow
import React from 'react';
import type { ChildrenArray, Element } from 'react';
import { usePropsValidation } from '../validation/runtime-checks/index.js';
import { types as t } from '../validation/runtime-checks/prop-spec.js';
import { Text } from '../Text.js';
import { Heading } from '../Heading.js';
import { productColor } from '../designSystem.js';

export default function TOVNarrative(props: {|
  children: ChildrenArray<Element<typeof Text>>,
|}) {
  const { failedValidation } = usePropsValidation(props, TOVNarrative);
  if (failedValidation) return null;
  return (
    <div style={{ color: productColor.shuttleGrey }}>
      <Heading>Topic narrative</Heading>
      {React.Children.map(props.children, (child, index) => (
        <React.Fragment key={index}>
          <div style={{ height: 20 }}> </div>
          {child}
        </React.Fragment>
      ))}
    </div>
  );
}

TOVNarrative.spec = {
  children: t.minimumCount(1, t.elementType(Text)),
};
